import { getReferrerIdByCode } from 'services/firebase/referralService';
import {
  getPromoCodeByCode,
  type PromoCodeConfig,
} from 'services/firebase/promoCodeService';

export interface SubscriptionCodeResult {
  type: 'referral';
  referrerId: string;
}

export interface PromoCodeResult {
  type: 'promo';
  promo: PromoCodeConfig;
}

export type SubscriptionCodeValidationResult =
  | SubscriptionCodeResult
  | PromoCodeResult;

export function normalizeSubscriptionCode(code: string): string {
  return code
    .replace(/\u00A0/g, ' ')
    .trim()
    .replace(/\s*-\s*/g, '-');
}

/**
 * Valida o código digitado na assinatura.
 * Ordem: primeiro tenta como código de indicação (usuário); depois como código promocional.
 * Retorna null se não for nenhum dos dois.
 */
export async function validateSubscriptionCode(
  code: string,
): Promise<SubscriptionCodeValidationResult | null> {
  const normalized = normalizeSubscriptionCode(code);
  if (!normalized || normalized.length < 2) return null;

  const referrerId = await getReferrerIdByCode(normalized);
  if (referrerId) {
    return { type: 'referral', referrerId };
  }

  const promo = await getPromoCodeByCode(normalized);
  if (promo) {
    return { type: 'promo', promo };
  }

  return null;
}
